import React from 'react';
import axios from 'axios';
import 'react-table/react-table.css';
import Pagination from 'react-js-pagination';
import { LinearProgress } from 'react-md';
import '../../../node_modules/react-md/dist/react-md.indigo-blue.min.css';
import 'bootstrap-datepicker/js/bootstrap-datepicker.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import ViewModal from './_modal/view';
import Loader from '../../_components/loader';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { AdminUrls } from '../../network/config';
import './style.css';
import { removeData } from '../../store/action';
import { connect } from 'react-redux';
import userIcon from '../../assets/Apps-User-icon.png';
import noIcon from '../../assets/no-icon.png';
import tickIcon from '../../assets/good_or_tick.png';
const moment = require('moment');

const Member_Record_URL = AdminUrls.ADMIN.CPDMEMBER;
const Send_Email_URL = AdminUrls.ADMIN.SENDEMAIL;
const Upload_File = AdminUrls.ADMIN.FILEUPLOAD;

class MemberAdmin extends React.Component {
  constructor() {
    super();

    this.handlePageChange = this.handlePageChange.bind(this);
    this.clearSearchFilters = this.clearSearchFilters.bind(this);
    this.getMembersData = this.getMembersData.bind(this);
    this.sendEmail = this.sendEmail.bind(this);
    this.editViewHandler = this.editViewHandler.bind(this);
    this.viewMemberCpdHandler = this.viewMemberCpdHandler.bind(this);

    this.state = {
      start_date: '',
      dashboard_records: [],

      totalPages: 0,
      totalCount: 0,
      activePage: 1,
      sort: {
        column: 'StartDate',
        direction: 'desc',
      },

      listViewModalShown: false,
      listViewDataCourseName: '',
      listViewDatastartDate: '',
      listViewDatacourseLocation: '',
      listViewDatacourseType: '',
      listViewDatahost: '',
      listViewDatacpdFormata: '',
      listViewDatavenue: '',
      listViewDatatrainer: '',
      listViewDatacourseDescription: '',
      mainLoading: false,
      emptyDivMsg: 'There is no data to show in the grid.',
      per_page: 10,
      page: 1,
      userName: '',
      isComaplaint: '',
      memberId: '',
      year: '',
      allData: [],
      viewEmail: '',
      viewTotalRecorded: '',
      viewStatus: '',
      viewUserName: '',
      sendEmailStatus: false,
      subjectEmail: '',
      queryEmail: '',
      file: '',
      file_upload: null,
      memberAdminErrorMessages: null,
    };
    this.controller = new AbortController();
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handlePageChange(pageNumber) {
    this.setState(
      {
        activePage: pageNumber,
      },
      () => {
        this.getMembersData(this?.state?.activePage);
      }
    );
  }

  handleInputChange(event) {
    const target = event.target;
    const name = target.name;
    if (name === 'file_upload') {
      if (event.target.files.length > 0) {
        this.setState({
          [name]: event.target.files[0],
          file_name: event.target.files[0].name,
        });
      }
    }
  }

  componentDidMount() {
    this.getMembersData(this.state.page, '');
  }

  getMembersData(pageNumber, years, column, direction) {
    this.setState({
      mainLoading: true,
    });

    let year = this.state.year;
    let obj = {
      page: pageNumber,
      pageSize: this.state.per_page,
    };
    if (years) {
      obj.year = years;
    } else {
      obj.year = '';
    }

    let username = this.state.userName;
    let compliant = this.state.isComaplaint;
    let memberid = this.state.memberId;

    if (column) {
      obj.sortBy = column;
    }

    if (direction) {
      direction = direction === 'asc' ? false : true;
      obj.reverse = direction;
    }

    if (username) {
      obj.userName = username;
    }
    if (compliant) {
      if (compliant === 'Yes') {
        compliant = true;
        obj.isComaplaint = compliant;
      } else {
        compliant = false;
        obj.isComaplaint = compliant;
      }
    }
    if (memberid) {
      obj.memberId = memberid;
    }
    if (year) {
      obj.year = year;
    }

    axios
      .get(Member_Record_URL, {
        params: obj,
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        if (data) {
          this.setState({
            allData: data.Items,
            activePage: data.Page,
            pageSize: data.Count,
            totalCount: data.TotalCount,
            mainLoading: false,
          });
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  sendEmail() {
    let obj = {
      subject: this.state.subjectEmail,
      query: this.state.queryEmail,
    };
    axios
      .post(Send_Email_URL, obj, {
        withCredentials: true,
        credentials: 'include',
        signal: this.controller.signal,
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })

      .then((data) => {
        NotificationManager.success(`Email Sent`);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          this.props.signOut();
        } else {
          NotificationManager.error(`Error! Feedback Failed. Try again.`);
        }
      });
    this.setState({
      listViewModalShown: false,
      sendEmailStatus: false,
    });
  }

  updatesubjectEmail = (subject) => {
    this.setState({ subjectEmail: subject });
  };
  updatequeryEmail = (query) => {
    this.setState({ queryEmail: query });
  };
  cancelUpload = () => {
    this.setState({ file: '' });
  };

  startUpload = () => {
    let blobFile = this.state.file_upload;
    let formData = new FormData();
    formData.append('file', blobFile);
    axios
      .post(Upload_File, formData, {
        processData: false,
        contentType: false,
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((data) => {
        NotificationManager.success(
          'Success!',
          'MyCPD Record Created Successfully'
        );
      })
      .catch((error) => {
        if (error && error?.response) {
          if (error.response.data && error.response.data.length > 0) {
            var x = '';
            for (const i in error.response.data) {
              x += error.response.data[i].ResultMessage + '-';
            }
            this.setState({ memberAdminErrorMessages: x });
          }
        }

        setTimeout(() => {
          this.setState({ memberAdminErrorMessages: null });
        }, 20000);

        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  };

  clearSearchFilters() {
    this.setState(
      {
        allData: [],
        sort: {
          column: 'StartDate',
          direction: 'desc',
        },
        totalPages: 0,
        totalCount: 0,
        per_page: 10,
        activePage: 0,
        year: '',
        memberId: '',
        isComaplaint: '',
        userName: '',
        mainLoading: false,
      },
      () => {
        this.getMembersData(1, '');
      }
    );
  }

  openModalWithItem() {
    this.setState({
      listViewDataCourseName: 'Member Snapshot',
      listViewModalShown: true,
    });
  }

  onSort = (column) => (e) => {
    const direction = this.state.sort.column
      ? this.state.sort.direction === 'asc'
        ? 'desc'
        : 'asc'
      : 'desc';
    this.setState({
      sort: {
        column,
        direction,
      },
    });
    this.getMembersData(1, '', column, direction);
  };

  setArrow = (column) => {
    let className = 'fa fa-sort';
    if (this.state.sort.column === column) {
      className += this.state.sort.direction === 'asc' ? '-asc' : '-desc';
    }
    return className;
  };

  editViewHandler(id, mode, item) {
    this.props.history.push({
      pathname: `myCpdRecord/${id}/${mode}`,
      state: item,
    });
  }

  viewMemberCpdHandler(id, userid) {
    let obj = {
      Id: id,
      uid: userid,
    };
    this.props.history.push({
      pathname: `my_cpd_report/${id}/${userid}`,
      state: obj,
    });
  }

  componentWillUnmount() {
    this.controller.abort();
  }

  render() {
    let listViewModalShownClose = () =>
      this.setState({ listViewModalShown: false });
    let dashboard_records;

    if (this.state.dashboard_records !== null) {
      dashboard_records = this.state.allData.map((dashboard_record, index) => {
        return (
          <tr key={index}>
            <td>
              <img src={userIcon} style={{ height: 30 }} alt="icon" />
            </td>
            <td>{dashboard_record.MemberNumber}</td>
            <td>{dashboard_record.username}</td>
            <td>
              <span
                style={{ fontWeight: 'normal' }}
                ng-class="{'label label-success': row.Status == 'Active' , 'label label-danger': row.Status == 'Terminated'}"
                className="label label-success"
              >
                <span className="ng-binding">{dashboard_record.Status}</span>
              </span>
            </td>
            <td>{moment(dashboard_record.userCompletionDate).format('ll')}</td>
            <td>
              {dashboard_record.IsCPDCompliant === 'False' ? (
                <img src={noIcon} alt="noIcon" />
              ) : (
                <img src={tickIcon} alt="tickIcon" style={{ height: 20 }} />
              )}
            </td>
            <td>{dashboard_record.Year}</td>
            <td style={{ display: 'flex ', justifyContent: 'center' }}>
              <div
                style={{
                  whiteSpace: 'nowrap',
                  display: 'block',
                }}
              >
                <a
                  data-item={dashboard_record}
                  onClick={() => {
                    this.openModalWithItem();
                    this.setState({
                      viewEmail: dashboard_record.Email,
                      viewTotalRecorded: dashboard_record.TotalRecorded,
                      viewStatus: dashboard_record.Status,
                      viewUserName: dashboard_record.username,
                      sendEmailStatus: false,
                    });
                  }}
                  style={{
                    fontSize: '21px',
                    cursor: 'pointer',
                    color: '#333333',
                  }}
                >
                  <i
                    className="fa fa fa-eye"
                    data-original-title="View Snapshot"
                    title="View Snapshot"
                  >
                    {' '}
                  </i>
                </a>
                <button
                  style={{
                    fontSize: '21px',
                    cursor: 'pointer',
                    marginLeft: '10px',
                    color: '#333333',
                    border: '0px',
                    background: 'transparent',
                  }}
                  onClick={() =>
                    this.viewMemberCpdHandler(
                      dashboard_record.MemberId,
                      dashboard_record.UserId
                    )
                  }
                >
                  <i
                    className="fa fa-folder-open ng-scope"
                    title="View Member CPD Details"
                    role="button"
                    tabIndex="0"
                    data-original-title="View Member CPD Details"
                  ></i>
                </button>
                <button
                  onClick={() =>
                    this.editViewHandler(
                      dashboard_record?.UserId,
                      'add',
                      dashboard_record
                    )
                  }
                  style={{
                    fontSize: '21px',
                    cursor: 'pointer',
                    marginLeft: '10px',
                    color: '#333333',
                    border: '0px',
                    background: 'transparent',
                  }}
                >
                  <i
                    className="fa fa-plus-circle ng-scope"
                    title="Add Member CPD"
                    role="button"
                    tabIndex="0"
                    data-original-title="Add Member CPD"
                  >
                    {' '}
                  </i>
                </button>
              </div>

              <div
                style={{
                  fontSize: '21px',
                  cursor: 'pointer',
                  marginLeft: '10px',
                  color: '#333333',
                  display: dashboard_record.CourseId != null ? 'none' : 'block',
                }}
              >
                <i
                  className="fa fa-paper-plane ng-scope"
                  title="Email Member"
                  onClick={() => {
                    this.openModalWithItem();
                    this.setState({
                      sendEmailStatus: true,
                      viewEmail: dashboard_record.Email,
                    });
                  }}
                >
                  {' '}
                </i>
              </div>
            </td>
          </tr>
        );
      });
    }
    return (
      <div>
        {this.state.mainLoading && <LinearProgress id="main-loader" />}
        <div>
          {this.state.memberAdminErrorMessages && (
            <div
              class="alert alert-danger alert-white rounded"
              ng-if="vm.errorMessage"
            >
              <button
                type="button"
                data-dismiss="alert"
                aria-hidden="true"
                ng-click="vm.hideErrorMessage()"
                class="close"
              >
                ×
              </button>
              <div class="icon">
                <i class="fa fa-times-circle"></i>
              </div>
              <strong>Error!</strong> {this.state.memberAdminErrorMessages}
            </div>
          )}

          <div className="panel panel-default">
            <div className="panel-heading-cpd-3" style={{ padding: '10px' }}>
              <i
                className="fa fa-filter "
                title=""
                data-original-title="Search"
              >
                {' '}
                Search
              </i>
            </div>

            <div className="shadow">
              <div className="layout-gt-sm-row">
                <div style={{ padding: '1rem 1rem' }}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group admin-member-forms">
                        <label>Name</label>
                        <input
                          type="name"
                          className="form-control"
                          id="name"
                          value={this.state.userName}
                          onChange={(e) =>
                            this.setState({ userName: e.target.value })
                          }
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              this.getMembersData(1);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group admin-member-forms">
                        <label>CPD Compliants</label>
                        <select
                          className="form-control"
                          id="sel1"
                          value={this.state.isComaplaint}
                          onChange={(e) =>
                            this.setState({ isComaplaint: e.target.value })
                          }
                        >
                          <option></option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group date admin-member-forms">
                        <label>Membership Number</label>

                        <input
                          type="text"
                          placeholder=""
                          className="form-control"
                          value={this.state.memberId}
                          onChange={(e) =>
                            this.setState({ memberId: e.target.value })
                          }
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              this.getMembersData(1);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group admin-member-forms">
                        <label>Year</label>
                        <select
                          className="form-control"
                          id="sel1"
                          value={this.state.year}
                          onChange={(e) =>
                            this.setState({ year: e.target.value })
                          }
                        >
                          <option></option>
                          <option value="2022">2022</option>
                          <option value="2023">2023</option>
                          <option value="2024">2024</option>
                          <option value="2025">2025</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div>
                    <button
                      className="btn btn-primary"
                      style={{ marginRight: '10px' }}
                      onClick={() => this.getMembersData(1)}
                    >
                      <span className="glyphicon glyphicon-search"> </span>{' '}
                      Search
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={() => this.clearSearchFilters()}
                    >
                      <span className="glyphicon glyphicon-remove-sign"> </span>{' '}
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="form-inline">
            <div className="shadow">
              <div className="row">
                <div className="col-md-4">
                  <button
                    type="button"
                    className="btn btn-success w-100"
                    style={{ padding: '0' }}
                  >
                    <label className="add-cvs-file">
                      <span>
                        <i className="glyphicon glyphicon-plus"></i>
                      </span>
                      <span>Add csv file</span>
                      <input
                        id="file_upload"
                        type="file"
                        name="file_upload"
                        className="hidden"
                        value={this.state.file}
                        onChange={this.handleInputChange}
                      />
                    </label>
                  </button>
                </div>
                <div className="col-md-8">
                  <button
                    type="button"
                    className="btn btn-primary start"
                    onClick={this.startUpload}
                  >
                    <i className="glyphicon glyphicon-upload"></i>
                    <span>Start upload</span>
                  </button>
                  <button
                    type="reset"
                    className="btn btn-warning cancel"
                    onClick={this.cancelUpload}
                  >
                    <i className="glyphicon glyphicon-ban-circle"></i>
                    <span>Cancel upload</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="gridTopButtons" style={{ paddingTop: '15px' }}>
            <button
              type="button"
              onClick={() => window.print()}
              className="btn btn-danger btn-circle btn-lg "
            >
              <i className="fa fa-print"> </i>
            </button>
          </div>
        </div>

        <div className="col-table-member">
          {this.state.mainLoading && <Loader />}
          <table className="table table-striped table-bordered table-hover table-condensed">
            <thead>
              <tr className="header">
                <th></th>
                <th onClick={this.onSort('MemberNumber')}>
                  Membership Number{' '}
                  <i className={this.setArrow('MemberNumber')}> </i>
                </th>
                <th onClick={this.onSort('username')}>
                  User Name <i className={this.setArrow('username')}> </i>
                </th>
                <th onClick={this.onSort('Status')}>
                  Status <i className={this.setArrow('Status')}> </i>
                </th>
                <th onClick={this.onSort('CompletionDate')}>
                  Completion Date{' '}
                  <i className={this.setArrow('CompletionDate')}> </i>
                </th>
                <th>CPD Compliant</th>
                <th onClick={this.onSort('Year')}>
                  Year <i className={this.setArrow('Year')}> </i>
                </th>

                <th></th>
              </tr>
            </thead>
            <tbody>{dashboard_records}</tbody>
          </table>
          {dashboard_records.length > 0 ? '' : this.state.emptyDivMsg}
        </div>
        <div>
          <Pagination
            prevPageText="Previous"
            nextPageText="Next"
            firstPageText="First"
            lastPageText="Last"
            activePage={this.state.activePage}
            itemsCountPerPage={this.state.per_page}
            totalItemsCount={this.state.totalCount}
            onChange={this.handlePageChange}
          />
        </div>

        <ViewModal
          show={this.state.listViewModalShown}
          data={this.state}
          onHide={listViewModalShownClose}
          viewEmail={this.state.viewEmail}
          viewTotalRecorded={this.state.viewTotalRecorded}
          viewStatus={this.state.viewStatus}
          viewUserName={this.state.viewUserName}
          sendEmailStatus={this.state.sendEmailStatus}
          updatesubjectEmail={this.updatesubjectEmail}
          updatequeryEmail={this.updatequeryEmail}
          sendEmail={this.sendEmail}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(removeData()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MemberAdmin);
